import React from 'react';
import styles from './AnnotationHint.module.css';
export default function AnnotationHelp() {
    return (React.createElement("div", { className: styles.modal },
        React.createElement("div", { className: styles.overlay }),
        React.createElement("div", { className: styles.table },
            React.createElement("div", { className: styles.tableCell },
                React.createElement("div", { className: styles.hint }, "Click anywhere on the image to add your annotation.")))));
}
